/**
 * Permission options are now sourced from the API (GET companies/{id}/permissions),
 * with display metadata maintained backend-side in App\Constants\PermissionCategories.
 * Only the meta-permission expansion map below remains frontend-side.
 */

/**
 * Meta-permissions: checking one of these options grants all of the listed
 * underlying permissions when the role is created or updated.
 */
export const groupedPermissions = {
  create_users: [
    'create_users',
    'update_users',
    'update_user_roles'
  ],
  create_documents: [
    'create_documents',
    'create_policies',
    'create_attachments'
  ],
  update_documents: [
    'update_documents',
    'update_policies',
    'update_attachments'
  ],
  archive_documents: [
    'archive_documents',
    'archive_policies'
  ],
  delete_documents: [
    'delete_documents',
    'delete_policies',
    'delete_attachments'
  ]
};

